<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <Field
      v-slot="{ field, errors }"
      v-model="optionalInformationStore.special_remarks"
      name="special_remarks"
    >
      <div class="input-group row pe-0">
        <div class="col-12 pe-0">
          <label class="form-label size-12" for="">その他</label>
          <textarea
            class="input-primary form-control bg-silver-primary p-0d8 size-14 border-0"
            rows="5"
            placeholder="プロフィールに追加する情報などあればご入力ください。"
            v-bind="field"
            :class="{ 'is-invalid': !!errors.length }"
          ></textarea>
          <div
            class="d-flex justify-content-end mt-2 size-10"
            :class="
              optionalInformationStore.special_remarks?.length > 1000
                ? 'text-danger'
                : 'text-black-50'
            "
          >
            {{ optionalInformationStore.special_remarks?.length || 0 }}
            /1000（最大文字数1000文字）
          </div>
          <ErrorMessage name="special_remarks" class="invalid-feedback" />
        </div>
      </div>
    </Field>
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage } from 'vee-validate';
import { useOptionalInformationStore } from '@/stores/resume-candidate/OptionalInformation.store';

const optionalInformationStore = useOptionalInformationStore();
</script>
